export const projectQueryKeys = {
  GET_PROJECT_QUERY: 'getProjectQuery',
  GET_MY_PROJECTS_QUERY: 'getMyProjectsQuery'
}
